import './index.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import ReactPlaceholder from 'react-placeholder';
import { TextBlock } from 'react-placeholder/lib/placeholders';
import View from '../../view';

const awesomePlaceholder = (
  <View>
    <View className="transaction-history-container">
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
    </View>
    <View className="transaction-history-container">
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
    </View>
    <View className="transaction-history-container">
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
    </View>
    <View className="transaction-history-container">
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
    </View>
    <View className="transaction-history-container">
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
    </View>
    <View className="transaction-history-container">
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
      <TextBlock
        style={{
          width: '90%'
        }}
        className="leaderboard-placeholder-text-block"
        rows={1}
        color="#fff"
      />
    </View>
  </View>
);

const TransactionHistory = () => {
  return (
    <ReactPlaceholder customPlaceholder={awesomePlaceholder} showLoadingAnimation ready={false}>
      <View>loader</View>
    </ReactPlaceholder>
  );
};

export default TransactionHistory;
